<template>
  <div class="d-inline-flex align-center justify-start h-100 px-2">
    <div v-for="(viewer, index) in caseViewers" :key="index">
      <UserAvatar size="25" status="active" :user-id="viewer.userId || viewer.id" :name="viewer.userDisplayName || viewer.displayName" :avatarOnly="avatarOnly" class="expansion-avatar mr-2"> </UserAvatar>
    </div>
    <span v-if="caseViewerOverflowCount > 0"> + {{ caseViewerOverflowCount }}</span>
  </div>
</template>

<script>
import UserAvatar from "@/components/Users/UserAvatar.vue"
import { mapState } from "vuex"

export default {
  name: "case-presence-display",
  components: { UserAvatar },
  props: {
    viewers: { default: () => [] },
    viewerMax: { default: () => 3 },
    bucketView: { default: () => false },
  },
  computed: {
    ...mapState({
      currentUserId: (state) => state.currentUser.me.id,
    }),
    avatarOnly() {
      if (this.bucketView) {
        return this.bucketView
      } else {
        return this.$vuetify.breakpoint.smAndDown
      }
    },
    caseViewers() {
      if (this.viewers && this.viewers.length > 0) {
        const all = this.viewers.filter((viewer) => viewer.id !== this.currentUserId) // Excluding current user
        return all.slice(0, this.viewerMax)
      } else {
        return []
      }
    },
    caseViewerOverflowCount() {
      if (this.viewers && this.viewers.length > this.viewerMax) {
        return this.bucketView ? this.viewers.length - this.viewerMax : this.viewers.length - this.viewerMax - 1 // Excluding current user
      } else {
        return 0
      }
    },
  },
}
</script>
